// fun fact: TypeScript does not handle the key name typing and autocomplete well when this module is a JSON file
// additionally, JSON doesn't allow comments, which we need here from time to time

/**
 * There are multiple locations in the backend and database (table: RecommendedScenarios) that serve up strings that are
 * not controlled through this framework.
 *
 * Reference PRs:
 * https://github.com/gremlin/service/pull/3437
 * https://github.com/gremlin/service/pull/3445
 */
import attacks from 'i18n/en/attacks'
import authenticatedRoutes from 'i18n/en/authenticated-routes'
import clients from 'i18n/en/clients'
import common from 'i18n/en/common'
import companyEntitlements from 'i18n/en/company_entitlements'
import companySummaryReportPdf from 'i18n/en/company_summary_report_pdf'
import failureFlags from 'i18n/en/failure_flags'
import forms from 'i18n/en/forms/index'
import general from 'i18n/en/general'
import gettingStarted from 'i18n/en/getting_started'
import haltAll from 'i18n/en/halt_all'
import httpResponseStatusCodes from 'i18n/en/http_response_status_codes'
import layouts from 'i18n/en/layouts'
import loadGenerators from 'i18n/en/load_generators'
import navigation from 'i18n/en/navigation'
import profile from 'i18n/en/profile'
import rbacSettings from 'i18n/en/rbac_settings'
import reliabilityManagement from 'i18n/en/reliability-management'
import restrictedTimeWindows from 'i18n/en/restricted_time_windows'
import scenarios from 'i18n/en/scenarios'
import scheduleWindow from 'i18n/en/schedule_window'
import service from 'i18n/en/service'
import serviceCatalog from 'i18n/en/service_catalog'
import serviceDetectedRisks from 'i18n/en/service_detected_risks'
import serviceSettings from 'i18n/en/service_settings'
import statusChecks from 'i18n/en/status_checks'
import supportRisks from 'i18n/en/support_risks'
import teamAuthentications from 'i18n/en/team_authentications'
import testSuites from 'i18n/en/test_suites'
import utils from 'i18n/en/utils'

/**
 * Consolidates all EN text string files
 */
export default {
  ...attacks,
  ...authenticatedRoutes,
  ...clients,
  ...common,
  ...companyEntitlements,
  ...companySummaryReportPdf,
  ...forms,
  ...failureFlags,
  ...gettingStarted,
  ...haltAll,
  ...httpResponseStatusCodes,
  ...layouts,
  ...loadGenerators,
  ...navigation,
  ...profile,
  ...rbacSettings,
  ...reliabilityManagement,
  ...restrictedTimeWindows,
  ...scenarios,
  ...scheduleWindow,
  ...service,
  ...serviceCatalog,
  ...serviceDetectedRisks,
  ...serviceSettings,
  ...statusChecks,
  ...supportRisks,
  ...teamAuthentications,
  ...utils,
  ...testSuites,
  ...general
}
